import React, { useContext } from "react";
import { useTheme } from "@mui/material";
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  Divider,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { AppContext } from "../contextProviders/AppContext";
import { centsToLocalString } from "../shared/money";
import { translation } from "./Dictionary";

import ReservationSchedule from "./ReservationSchedule";
import PriceSummary from "./PriceSummary";

export default function OrderSummary({
  discountedTotalPrice,
  showPrice = true,
}) {
  const {
    cart,
    reservationReturn,
    reservationStart,
    selectedAdditionalServices,
    mobileViewPort,
    language,
  } = useContext(AppContext);

  const theme = useTheme();

  // If nothing to show then don't show the accordion
  if (!cart.length) {
    return;
  }
  const orderVatAmounts = calculateVATofPrice(cart, selectedAdditionalServices);

  return (
    <Accordion
      elevation={0}
      defaultExpanded
      sx={{ marginTop: "15px", width: "100%", bgcolor: "transparent" }}
    >
      {/* RESERVATION INFO */}
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="reservation-order-summary-content"
        id="reservation-order-summary-header"
        sx={{ maxWidth: "inherit" }}
      >
        <Box sx={{ display: "flex", width: "100%" }}>
          <Typography
            style={{
              margin: 0,
              padding: 0,
              fontFamily: "Sofia Pro",
              fontSize: 20,
              fontWeight: 600,
            }}
          >
            {translation.get(language, "Order summary")}
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails sx={{ padding: 0, maxWidth: "inherit" }}>
        {reservationStart && reservationReturn && (
          <Box style={{ height: "100%", maxWidth: "inherit" }}>
            <Box sx={{ margin: "20px" }}>
              <ReservationSchedule />
            </Box>

            <PriceSummary />
          </Box>
        )}

        {mobileViewPort && <Divider sx={{ color: "black" }} />}
      </AccordionDetails>
    </Accordion>
  );
}

export function calculateVATofPrice(cart, selectedAdditionalServices) {
  if (!Array.isArray(cart)) {
    console.error("Expected cart to be an array, but got:", typeof cart);
    return null;
  }

  const vatTotals = {};

  cart.forEach((item) => {
    const vatPercentage = item?.tax || item?.vehicle?.tax;
    const vatAmount = calculateVAT(item.offerPrice, vatPercentage);

    if (vatPercentage && vatTotals[vatPercentage]) {
      vatTotals[vatPercentage] += vatAmount;
    } else {
      vatTotals[vatPercentage] = vatAmount;
    }
  });

  selectedAdditionalServices.forEach((item) => {
    const vatPercentage = item?.tax;
    const vatAmount = calculateVAT(item.offerPrice, vatPercentage);

    if (vatPercentage && vatTotals[vatPercentage]) {
      vatTotals[vatPercentage] += vatAmount;
    } else {
      vatTotals[vatPercentage] = vatAmount;
    }
  });

  const result = Object.keys(vatTotals).map((key) => ({
    [key]: vatTotals[key],
  }));

  return result;
}

export const calculateVAT = (value, tax) => {
  const taxValue = tax / 100 + 1;
  const taxPercentage = 1 - 1 / taxValue;
  return Math.ceil(value * taxPercentage);
};

export const valueExcludedVAT = (value) => {
  return centsToLocalString(value - calculateVAT(value));
};
